export const pinTitle = "HtDADb";
export const settingsTitle = "D0Rxtb";
export default {pinTitle,settingsTitle};